/* Klaviyo Popup Override — Apo.Ge
   v2 (2026-08-14): honeycomb design from Figma "Apo.Ge Website" > Popup page.
   Restructures the Klaviyo popup DOM for brand styling:
   inner cream card, honey halo circle, YOUER two-line secondary button.
   Checkbox multi-select machinery (yellow dots) preserved from v1 —
   any number of skin concerns can be selected; state is mirrored from the
   real Klaviyo checkboxes onto label.apoge-checked.
   Companion: klaviyo-popup-override.css */

(function () {

  function findPopupForm() {
    var dialogs = document.querySelectorAll('[role="dialog"]');
    for (var d = 0; d < dialogs.length; d++) {
      var form = dialogs[d].querySelector('.klaviyo-form');
      if (form) return form;
    }
    return null;
  }

  function initPopup() {
    var popup = findPopupForm();
    if (!popup) return false;
    if (popup.dataset.apogeInitialized === 'true') return true;

    var container = popup.querySelector(':scope > div > div:first-child');
    if (!container) return false;

    var isMobile = window.innerWidth < 750;

    // 1. Wrap all rows in inner card
    if (!container.querySelector('.apoge-inner-card')) {
      var innerCard = document.createElement('div');
      innerCard.className = 'apoge-inner-card';
      while (container.firstChild) {
        innerCard.appendChild(container.firstChild);
      }
      container.appendChild(innerCard);
    }

    var inner = container.querySelector('.apoge-inner-card');
    if (!inner) return false;

    // 2. Honey halo circle behind the card (styled + sized in CSS)
    if (!popup.querySelector('.apoge-halo')) {
      var halo = document.createElement('div');
      halo.className = 'apoge-halo';
      popup.insertBefore(halo, popup.firstChild);
    }

    // 3. Hide empty spacer rows
    var rows = inner.querySelectorAll('[data-testid="form-row"]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].parentNode !== inner) continue;
      var text = rows[i].textContent.trim();
      if (text === '' || text === '​') {
        rows[i].style.display = 'none';
      }
    }

    // 4. Outer container sizing (z-index lifts the card above the halo)
    if (isMobile) {
      container.style.cssText = 'display:flex; flex-direction:column; width:100%; max-width:100%; min-width:0; margin:0; padding:0; justify-content:center; box-sizing:border-box; position:relative; z-index:1; background-image:none; background-color:transparent; border-radius:0; box-shadow:none; overflow:visible;';
      popup.style.padding = '0';
    } else {
      container.style.cssText = 'display:flex; flex-direction:column; width:616px; max-width:616px; min-width:616px; margin:0 auto; padding:40px; justify-content:center; box-sizing:border-box; position:relative; z-index:1;';
    }

    // 5. Heading — DM Serif Display (Klaviyo applies inline styles, so CSS
    // alone can't win; must set inline here)
    var allRichtext = popup.querySelectorAll('.klaviyo-form-richtext');
    var headingRt = null;
    for (var r = 0; r < allRichtext.length; r++) {
      if (allRichtext[r].textContent.trim().length > 5) {
        headingRt = allRichtext[r];
        break;
      }
    }
    if (headingRt) {
      var ps = headingRt.querySelectorAll('p');
      if (ps[0]) {
        ps[0].style.fontFamily = '"DM Serif Display", serif';
        ps[0].style.fontSize = isMobile ? '32px' : '40px';
        ps[0].style.fontWeight = '400';
        ps[0].style.letterSpacing = '0.6px';
        ps[0].style.lineHeight = '1.3';
        ps[0].style.color = 'rgb(79, 81, 39)';
      }
      var headingSpan = ps[0] ? ps[0].querySelector('span') : null;
      if (headingSpan) {
        headingSpan.style.fontFamily = '"DM Serif Display", serif';
        headingSpan.style.fontSize = isMobile ? '32px' : '40px';
        headingSpan.style.fontWeight = '400';
        headingSpan.style.color = 'rgb(79, 81, 39)';
      }
      var strong = headingRt.querySelector('strong');
      if (strong) strong.style.fontWeight = '400';
      if (ps[1]) {
        ps[1].style.textAlign = 'center';
        ps[1].style.marginTop = '12px';
      }
    }

    // 6. Buttons — compact the CTA to 44px; rebuild the YOUER button
    var buttons = popup.querySelectorAll('.klaviyo-form-button');
    for (var b = 0; b < buttons.length; b++) {
      var btnText = buttons[b].textContent;
      if (btnText.indexOf('GET 10%') !== -1) {
        buttons[b].style.cssText += '; height:44px !important; min-height:0 !important; padding:0 24px !important; font-size:13px !important; max-height:44px !important;';
      } else if (/youer|find us/i.test(btnText) && buttons[b].dataset.apogeYouer !== 'true') {
        buildYouerButton(buttons[b]);
      }
    }

    // 7. Squash button row wrappers
    var children = inner.children;
    for (var c = 0; c < children.length; c++) {
      if (children[c].style.display === 'none') continue;
      var t = children[c].textContent;
      var isCtaRow = t.indexOf('GET 10% OFF') !== -1;
      var isYouerRow = children[c].querySelector('.apoge-youer-btn') !== null;
      if (isCtaRow || isYouerRow) {
        children[c].style.cssText += '; height:auto !important; min-height:0 !important; padding:0 !important;';
        var comp = children[c].querySelector('[data-testid="form-component"]');
        if (comp) comp.style.cssText += '; height:auto !important; min-height:0 !important; padding:0 !important;';
      }
    }

    // 8. Even spacing between visible rows
    var visible = [];
    for (var v = 0; v < children.length; v++) {
      if (children[v].style.display !== 'none' && children[v].offsetHeight > 0) {
        visible.push(children[v]);
      }
    }
    for (var s = 0; s < visible.length; s++) {
      visible[s].style.marginTop = '0';
      visible[s].style.marginBottom = (s < visible.length - 1) ? '16px' : '0';
    }

    // 9. Checkbox row spacing
    var fieldset = popup.querySelector('.klaviyo-checkboxes fieldset');
    if (fieldset) {
      var fieldChildren = fieldset.children;
      for (var f = 0; f < fieldChildren.length; f++) {
        fieldChildren[f].style.marginBottom = '8px';
        fieldChildren[f].style.paddingTop = '4px';
        fieldChildren[f].style.paddingBottom = '4px';
      }
    }
    var labels = popup.querySelectorAll('.klaviyo-checkboxes label');
    for (var l = 0; l < labels.length; l++) {
      labels[l].style.paddingTop = '6px';
      labels[l].style.paddingBottom = '6px';
      labels[l].style.display = 'flex';
      labels[l].style.alignItems = 'center';
    }

    // 10. Close button — position/badge/colors live in CSS; here only the
    // glyph geometry and neutralizing Klaviyo's drawn circle
    var closeBtn = popup.closest('[role="dialog"]');
    closeBtn = closeBtn ? closeBtn.querySelector('.klaviyo-close-form') : document.querySelector('.klaviyo-close-form');
    if (closeBtn) {
      var svg = closeBtn.querySelector('svg');
      if (svg) {
        var glyph = isMobile ? '22' : '16';
        svg.setAttribute('width', glyph);
        svg.setAttribute('height', glyph);
      }
      var path = closeBtn.querySelector('path');
      if (path) {
        path.setAttribute('stroke', '#FFF8EF');
        path.setAttribute('stroke-width', '1.5');
        path.setAttribute('fill', 'none');
        path.style.stroke = '#FFF8EF';
      }
      var circle = closeBtn.querySelector('circle');
      if (circle) {
        circle.setAttribute('stroke', 'rgba(0,0,0,0)');
        circle.setAttribute('fill', 'rgba(0,0,0,0)');
      }
    }

    // 11. Hide all SVG checkboxes
    hideSVGs();

    // 12. Checkbox click handler — multi-select state mirror (PRESERVE:
    // this is what lets more than one concern be selected with yellow dots)
    var checkboxArea = popup.querySelector('.klaviyo-checkboxes');
    if (checkboxArea && !checkboxArea.dataset.apogeHandled) {
      checkboxArea.dataset.apogeHandled = 'true';
      checkboxArea.addEventListener('click', function () {
        setTimeout(function () {
          updateDots();
          hideSVGs();
        }, 50);
        setTimeout(function () {
          updateDots();
          hideSVGs();
        }, 150);
      });
    }

    // 13. Remove text highlight backgrounds
    var bgSpans = popup.querySelectorAll('.klaviyo-form-richtext span[data-color]');
    for (var bg = 0; bg < bgSpans.length; bg++) {
      bgSpans[bg].style.backgroundColor = 'transparent';
    }

    // 14. Flag popup-open on <html> — CSS uses it to hide the Smile.io
    // rewards launcher while the popup is up (removed on Klaviyo close event)
    document.documentElement.classList.add('apoge-popup-open');

    // 15. Make overlay transparent now that inner card is built
    // (NEVER do this in CSS — pre-init transparency makes the popup render
    // invisible while Klaviyo counts it as viewed and suppresses re-display)
    var dialog = popup.closest('[role="dialog"]');
    if (dialog) dialog.style.backgroundColor = 'transparent';

    // 16. Disconnect observer — job done
    if (observer) observer.disconnect();

    popup.dataset.apogeInitialized = 'true';
    return true;
  }

  // Restore the rewards launcher when the popup closes, and re-run the full
  // restructure when a form (re)opens — Klaviyo builds a fresh DOM on every
  // open, and the MutationObserver is disconnected after the first pass.
  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail) return;
    if (e.detail.type === 'close') {
      document.documentElement.classList.remove('apoge-popup-open');
    } else if (e.detail.type === 'open') {
      document.documentElement.classList.add('apoge-popup-open');
      tryInit(0);
    }
  });

  /* Rebuild the Klaviyo YOUER action button into the two-line block from the
     Figma design. The click action (go to /pages/welcome) is Klaviyo's own
     listener on the button element — child spans bubble up, so navigation
     survives the rebuild. */
  function buildYouerButton(btn) {
    btn.dataset.apogeYouer = 'true';
    btn.classList.add('apoge-youer-btn');
    while (btn.firstChild) btn.removeChild(btn.firstChild);

    var row = document.createElement('span');
    row.className = 'apoge-youer-row';

    var lead = document.createElement('span');
    lead.textContent = 'did you find us from';
    row.appendChild(lead);

    var logo = document.createElement('span');
    logo.className = 'apoge-youer-logo';
    logo.setAttribute('role', 'img');
    logo.setAttribute('aria-label', 'youer');
    row.appendChild(logo);

    var q = document.createElement('span');
    q.textContent = '?';
    row.appendChild(q);

    var link = document.createElement('span');
    link.className = 'apoge-youer-link';
    link.textContent = 'click here';

    btn.appendChild(row);
    btn.appendChild(link);
  }

  function hideSVGs() {
    var svgs = document.querySelectorAll('.klaviyo-checkboxes label svg');
    for (var i = 0; i < svgs.length; i++) {
      svgs[i].style.cssText = 'display:none !important; width:0; height:0; position:absolute;';
    }
  }

  function updateDots() {
    var labels = document.querySelectorAll('.klaviyo-checkboxes label');
    for (var i = 0; i < labels.length; i++) {
      var isChecked = false;
      var inputId = labels[i].getAttribute('for');
      if (inputId) {
        var input = document.getElementById(inputId);
        if (input && input.checked) isChecked = true;
      }
      if (isChecked) {
        labels[i].classList.add('apoge-checked');
      } else {
        labels[i].classList.remove('apoge-checked');
      }
    }
  }

  // Watch for popup to appear
  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      if (mutations[m].addedNodes.length) {
        var popup = findPopupForm();
        if (popup && popup.dataset.apogeInitialized !== 'true') {
          tryInit(0);
          break;
        }
      }
    }
  });

  function tryInit(attempt) {
    if (attempt > 5) return;
    var success = initPopup();
    if (!success) {
      setTimeout(function () { tryInit(attempt + 1); }, 300);
    }
  }

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (findPopupForm()) {
    tryInit(0);
  }
})();
